import { render, staticRenderFns } from "./sin.vue?vue&type=template&id=3297c20e&scoped=true"
import script from "./sin.vue?vue&type=script&lang=js"
export * from "./sin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3297c20e",
  null
  
)

export default component.exports